import { useState, useEffect, useCallback } from 'react';
import CreateDriver from './CreateDriver';

// Inject Google Inter font once
if (!document.getElementById('vp-font-inter')) {
    const l = document.createElement('link');
    l.id = 'vp-font-inter';
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap';
    document.head.appendChild(l);
}

const API = '/api';

/* ── Icon ── */
const Icon = ({ d, size = 18, color = 'currentColor', strokeWidth = 1.8 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
        stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
        {Array.isArray(d) ? d.map((p, k) => <path key={k} d={p} />) : <path d={d} />}
    </svg>
);

const icons = {
    overview: ['M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z', 'M9 22V12h6v10'],
    fleet: ['M7 17m-2 0a2 2 0 1 0 4 0 2 2 0 1 0-4 0', 'M17 17m-2 0a2 2 0 1 0 4 0 2 2 0 1 0-4 0', 'M5 17H3V7c0-1.1.9-2 2-2h11v12h-2', 'M19 17h2v-6l-3-4h-2v7h4'],
    docs: ['M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z', 'M14 2v6h6', 'M16 13H8', 'M16 17H8', 'M10 9H8'],
    contracts: ['M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2', 'M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2', 'M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2', 'M12 12h3', 'M12 16h3', 'M9 12h.01', 'M9 16h.01'],
    pricing: ['M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6'],
    profile: ['M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2', 'M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z'],
    logout: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'M16 17l5-5-5-5', 'M21 12H9'],
    trips: ['M5 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3', 'M14 17H9m10 0h3m-3 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm1-10h.01'],
    analytics: ['M3 3v18h18', 'M18 17l-6-6-4 4-4-4'],
    chevron: 'M9 18l6-6-6-6',
    pin: ['M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z', 'M12 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z'],
    phone: ['M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.21 12 19.79 19.79 0 0 1 1.1 3.4A2 2 0 0 1 3.07 1H6a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z'],
    mail: ['M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z', 'M22 6l-10 7L2 6'],
    tag: ['M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z', 'M7 7h.01'],
    check: 'M20 6L9 17l-5-5',
    building: ['M3 21h18', 'M3 7v1a3 3 0 0 0 6 0V4', 'M9 8a3 3 0 0 0 6 0V4', 'M15 8a3 3 0 0 0 6 0V7H3'],
    drivers: ['M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2', 'M9 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M23 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
    plus: 'M12 5v14M5 12h14',
    edit: 'M11 4H4a2 2 0 00-2 2v14a2 2 0 00 2 2h14a2 2 0 00 2-2v-7 M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z',
    trash: 'M3 6h18 M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2 M10 11v6 M14 11v6',
    x: 'M18 6L6 18 M6 6l12 12',
    save: 'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z M17 21v-8H7v8 M7 3v5h8',
    trip: ['M5 12h14', 'M12 5l7 7-7 7'],
    invoice: ['M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z', 'M14 2v6h6', 'M12 18h2', 'M12 14h2', 'M12 10h2', 'M8 18h2', 'M8 14h2', 'M8 10h2'],
    quote: ['M8 21h8a2 2 0 0 0 2-2v-9l-5-5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z', 'M13 5v5h5', 'M8 13h4', 'M8 17h6'],
    bell: ['M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9', 'M13.73 21a2 2 0 0 1-3.46 0'],
    send: ['M22 2L11 13', 'M22 2L15 22 11 13 2 9l20-7z'],
    alertCircle: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M12 8v4', 'M12 16h.01'],
};

const NAV_GROUPS = [
    {
        label: 'Main',
        items: [
            { key: 'overview', label: 'Overview', icon: 'overview' },
            { key: 'trips', label: 'Trips', icon: 'trip', badgeKey: 'pendingTrips' },
        ]
    },
    {
        label: 'Management',
        items: [
            { key: 'fleet', label: 'Manage Fleet', icon: 'fleet' },
            { key: 'drivers', label: 'Manage Drivers', icon: 'drivers' },
        ]
    },
    {
        label: 'Finance',
        items: [
            { key: 'invoices', label: 'Invoices', icon: 'invoice' },
            { key: 'quotations', label: 'Quotations', icon: 'quote' },
            { key: 'pricing', label: 'Manage Pricing', icon: 'pricing' },
        ]
    },
    {
        label: 'Legal & Info',
        items: [
            { key: 'documents', label: 'Documents', icon: 'docs' },
            { key: 'contracts', label: 'Contracts', icon: 'contracts' },
            { key: 'profile', label: 'Manage Profile', icon: 'profile' },
        ]
    }
];

/* ─────────────────────── SIDEBAR ─────────────────────── */
function VendorSidebar({ activePage, onNavigate, vendor, onLogout, operatorDetails, badges, notifications, onMarkAllRead }) {
    const [showNotifPanel, setShowNotifPanel] = useState(false);
    const unreadCount = notifications.filter(n => !n.isRead).length;

    const typeColor = (type) => {
        if (type === 'trip_assigned') return '#f59e0b';
        if (type === 'vendor_responded') return '#3b82f6';
        if (type === 'trip_accepted') return '#10b981';
        if (type === 'trip_rejected') return '#ef4444';
        return '#6b7280';
    };

    return (
        <aside style={sb.root}>
            {/* Brand */}
            <div style={sb.brand}>
                <div style={sb.brandIcon}>
                    {operatorDetails?.companyLogo ? (
                        <img
                            src={`${API}/uploads/${operatorDetails.companyLogo}`}
                            alt={operatorDetails?.companyName}
                            style={{ width: '100%', height: '100%', borderRadius: 12, objectFit: 'contain' }}
                        />
                    ) : (
                        <Icon d={icons.building} size={22} color="white" />
                    )}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={sb.brandName}>{operatorDetails?.companyName || 'Opsmaticz'}</div>
                    <div style={sb.brandSub}>Vendor Portal</div>
                </div>
                {/* Notification Bell */}
                <div style={{ position: 'relative' }}>
                    <button
                        onClick={() => setShowNotifPanel(p => !p)}
                        style={{ background: unreadCount > 0 ? '#fef3c7' : '#f3f4f6', border: `1px solid ${unreadCount > 0 ? '#fde68a' : '#e5e7eb'}`, cursor: 'pointer', padding: '7px 8px', position: 'relative', display: 'flex', alignItems: 'center', borderRadius: 10 }}
                        title="Notifications"
                    >
                        <Icon d={icons.bell} size={17} color={unreadCount > 0 ? '#d97706' : '#6b7280'} />
                        {unreadCount > 0 && (
                            <span style={{ position: 'absolute', top: -5, right: -5, background: '#ef4444', color: 'white', borderRadius: '50%', width: 17, height: 17, fontSize: 9, fontWeight: 900, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 6px rgba(239,68,68,0.5)' }}>{unreadCount > 9 ? '9+' : unreadCount}</span>
                        )}
                    </button>
                    {showNotifPanel && (
                        <div style={{ position: 'fixed', top: 0, left: 256, height: '100vh', width: 340, background: '#ffffff', boxShadow: '4px 0 32px rgba(0,0,0,0.14)', borderLeft: '1px solid #e5e7eb', zIndex: 998, display: 'flex', flexDirection: 'column', fontFamily: FONT }} onClick={e => e.stopPropagation()}>
                            {/* Panel Header */}
                            <div style={{ padding: '24px 20px 16px', background: 'linear-gradient(135deg,#ecfdf5,#f0fdf4)', borderBottom: '1px solid #d1fae5' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div>
                                        <div style={{ fontWeight: 800, fontSize: 16, color: '#064e3b', letterSpacing: '-0.02em' }}>Notifications</div>
                                        <div style={{ fontSize: 12, color: '#6b7280', marginTop: 3 }}>{unreadCount > 0 ? `${unreadCount} unread` : 'All caught up!'}</div>
                                    </div>
                                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                        {unreadCount > 0 && (
                                            <button onClick={onMarkAllRead} style={{ fontSize: 11, color: '#059669', background: 'white', border: '1px solid #a7f3d0', borderRadius: 8, cursor: 'pointer', fontWeight: 700, padding: '5px 10px', fontFamily: FONT }}>Mark all read</button>
                                        )}
                                        <button onClick={() => setShowNotifPanel(false)} style={{ background: 'white', border: '1px solid #e5e7eb', borderRadius: 8, width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                            <Icon d={icons.x} size={14} color="#6b7280" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/* Notification List */}
                            <div style={{ flex: 1, overflowY: 'auto' }}>
                                {notifications.length === 0 ? (
                                    <div style={{ padding: 48, textAlign: 'center', color: '#9ca3af' }}>
                                        <Icon d={icons.bell} size={40} color="#d1fae5" />
                                        <div style={{ marginTop: 12, fontWeight: 700, fontSize: 14, color: '#374151' }}>No notifications yet</div>
                                        <div style={{ marginTop: 4, fontSize: 12 }}>You're all caught up!</div>
                                    </div>
                                ) : notifications.map((n, i) => (
                                    <div key={n._id} style={{ padding: '14px 20px', borderBottom: '1px solid #f3f4f6', background: n.isRead ? 'white' : '#fffbeb', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                                        <div style={{ width: 38, height: 38, borderRadius: 12, background: typeColor(n.type) + '20', border: `1.5px solid ${typeColor(n.type)}40`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                            <div style={{ width: 10, height: 10, borderRadius: '50%', background: typeColor(n.type) }} />
                                        </div>
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                                                <div style={{ fontSize: 13, fontWeight: 700, color: '#111827', lineHeight: 1.35 }}>{n.title}</div>
                                                {!n.isRead && <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#f59e0b', flexShrink: 0, marginTop: 4, display: 'block' }} />}
                                            </div>
                                            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4, lineHeight: 1.5 }}>{n.message}</div>
                                            <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 6, fontWeight: 500 }}>{new Date(n.createdAt).toLocaleString()}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>


            {/* Vendor Info Card */}
            <div style={sb.vendorCard}>
                <div style={sb.vendorAvatar}>
                    {vendor?.vendorName?.charAt(0)?.toUpperCase() || 'V'}
                </div>
                <div style={sb.vendorInfo}>
                    <div style={sb.vendorName}>{vendor?.vendorName}</div>
                    {vendor?.rating ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 3, marginTop: 4, marginBottom: 2 }}>
                            {[1, 2, 3, 4, 5].map(s => (
                                <svg key={s} width="11" height="11" viewBox="0 0 24 24"
                                    fill={s <= vendor.rating ? '#f59e0b' : 'none'}
                                    stroke={s <= vendor.rating ? '#f59e0b' : '#d1d5db'}
                                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                            ))}
                            <span style={{ fontSize: 9.5, fontWeight: 700, color: '#b45309', marginLeft: 2 }}>
                                {['', 'Poor', 'Fair', 'Good', 'Very Good', 'Excellent'][vendor.rating]}
                            </span>
                        </div>
                    ) : null}
                    <div style={sb.vendorBadge}>
                        <span style={{ ...sb.dot, background: vendor?.status === 'Active' ? '#10b981' : '#f59e0b' }} />
                        {vendor?.status || 'Active'}
                    </div>
                </div>
            </div>

            {/* Nav */}
            <nav style={sb.nav}>
                {NAV_GROUPS.map(group => (
                    <div key={group.label} style={{ marginBottom: 12 }}>
                        <div style={sb.navLabel}>{group.label}</div>
                        {group.items.map(item => {
                            const active = activePage === item.key;
                            const badgeCount = item.badgeKey ? (badges[item.badgeKey] || 0) : 0;
                            return (
                                <button
                                    key={item.key}
                                    onClick={() => onNavigate(item.key)}
                                    style={{ ...sb.navBtn, ...(active ? sb.navBtnActive : {}) }}
                                >
                                    <span style={{ ...sb.navIcon, ...(active ? sb.navIconActive : {}) }}>
                                        <Icon d={icons[item.icon]} size={17} color={active ? '#059669' : '#9ca3af'} />
                                    </span>
                                    <span style={sb.navLabel2}>{item.label}</span>
                                    {badgeCount > 0 && (
                                        <span style={{ background: '#f59e0b', color: 'white', borderRadius: 10, fontSize: 10, fontWeight: 800, padding: '1px 7px', marginLeft: 'auto' }}>
                                            {badgeCount}
                                        </span>
                                    )}
                                    {active && !badgeCount && <span style={sb.navPip} />}
                                </button>
                            );
                        })}
                    </div>
                ))}
            </nav>

            {/* Footer */}
            <div style={sb.foot}>
                <div style={sb.footEmail} title={vendor?.email}>{vendor?.email}</div>
                <button onClick={onLogout} style={sb.logoutBtn}>
                    <Icon d={icons.logout} size={16} color="#ef4444" />
                    <span>Sign Out</span>
                </button>
            </div>
        </aside>
    );
}

const FONT = "'Inter',system-ui,sans-serif";

const sb = {
    root: {
        width: 256, minHeight: '100vh',
        background: '#ffffff',
        borderRight: '1px solid #e5e7eb',
        display: 'flex', flexDirection: 'column',
        fontFamily: FONT, flexShrink: 0,
        boxShadow: '2px 0 16px rgba(0,0,0,0.06)',
    },
    brand: {
        padding: '22px 20px 18px', display: 'flex', alignItems: 'center', gap: 12,
        borderBottom: '1px solid #f0fdf4',
    },
    brandIcon: {
        width: 42, height: 42, borderRadius: 12,
        background: 'linear-gradient(135deg,#10b981,#059669)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 4px 14px rgba(16,185,129,0.3)', flexShrink: 0,
    },
    brandName: { fontSize: 14, fontWeight: 800, color: '#064e3b', letterSpacing: '-0.01em' },
    brandSub: { fontSize: 9.5, fontWeight: 700, color: '#10b981', letterSpacing: '0.1em', textTransform: 'uppercase', marginTop: 2 },

    vendorCard: {
        margin: '14px 12px 8px', padding: '12px 14px', borderRadius: 14,
        background: 'linear-gradient(135deg,#ecfdf5,#f0fdf4)', border: '1px solid #a7f3d0',
        display: 'flex', alignItems: 'center', gap: 12,
    },
    vendorAvatar: {
        width: 38, height: 38, borderRadius: 10,
        background: 'linear-gradient(135deg,#10b981,#059669)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: 'white', fontWeight: 900, fontSize: 17, flexShrink: 0,
    },
    vendorInfo: { flex: 1, minWidth: 0 },
    vendorName: { fontSize: 13, fontWeight: 700, color: '#065f46', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    vendorBadge: { display: 'flex', alignItems: 'center', gap: 5, marginTop: 3, fontSize: 10.5, color: '#059669', fontWeight: 600 },
    dot: { width: 6, height: 6, borderRadius: '50%', display: 'inline-block' },

    nav: { flex: 1, padding: '6px 10px', display: 'flex', flexDirection: 'column', gap: 1, overflowY: 'auto' },
    navLabel: { fontSize: 9.5, fontWeight: 700, color: '#9ca3af', letterSpacing: '0.1em', textTransform: 'uppercase', padding: '14px 12px 5px' },
    navLabel2: { flex: 1, fontSize: 13, fontWeight: 500, letterSpacing: '-0.01em' },
    navBtn: {
        display: 'flex', alignItems: 'center', gap: 11, padding: '9px 12px',
        borderRadius: 10, border: 'none', background: 'transparent', cursor: 'pointer',
        color: '#6b7280', fontFamily: FONT, width: '100%', textAlign: 'left',
        transition: 'all 0.15s', position: 'relative',
    },
    navBtnActive: {
        background: '#ecfdf5', color: '#065f46', fontWeight: 700,
    },
    navIcon: { display: 'flex', alignItems: 'center', padding: '7px', borderRadius: 9, background: '#f3f4f6', flexShrink: 0 },
    navIconActive: { background: '#d1fae5' },
    navPip: {
        position: 'absolute', right: 10, width: 5, height: 5, borderRadius: '50%',
        background: '#10b981', boxShadow: '0 0 6px rgba(16,185,129,0.6)',
    },

    foot: {
        padding: '14px 16px', borderTop: '1px solid #f3f4f6', display: 'flex',
        flexDirection: 'column', gap: 9,
    },
    footEmail: {
        fontSize: 11, color: '#9ca3af', fontWeight: 500,
        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingLeft: 4,
    },
    logoutBtn: {
        display: 'flex', alignItems: 'center', gap: 8,
        background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10,
        color: '#dc2626', fontWeight: 700, fontSize: 12, cursor: 'pointer',
        padding: '9px 14px', fontFamily: FONT, width: '100%',
    },
};

/* ─────────────────────── PAGES ─────────────────────── */

/* Overview */
function OverviewPage({ vendor, fleet, docs, contracts, pricing, trips, invoices, quotations, operatorDetails, onNavigate }) {
    const pendingTrips = trips.filter(t => t.vendorStatus === 'Pending Vendor' || t.vendorStatus === 'Not Assigned');
    const acceptedTrips = trips.filter(t => t.vendorStatus === 'Accepted');
    const proposedTrips = trips.filter(t => t.vendorStatus === 'Vendor Proposed');

    const scheduledCount = trips.filter(t => t.vendorStatus === 'Accepted' && (t.status === 'Scheduled' || t.status === 'Requested')).length;
    const ongoingCount = trips.filter(t => t.status === 'Ongoing' || t.status === 'In Progress').length;
    const completedCount = trips.filter(t => t.status === 'Completed').length;

    const tripCards = [
        { label: 'Scheduled', count: scheduledCount, icon: icons.trips, gradient: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', status: 'Scheduled' },
        { label: 'Ongoing', count: ongoingCount, icon: icons.analytics, gradient: 'linear-gradient(135deg, #b45309 0%, #f59e0b 100%)', status: 'Ongoing' },
        { label: 'Completed', count: completedCount, icon: icons.check, gradient: 'linear-gradient(135deg, #047857 0%, #10b981 100%)', status: 'Completed' },
    ];
    const rejectedTrips = trips.filter(t => t.vendorStatus === 'Rejected');
    const recentTrips = [...trips].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 5);

    const kpis = [
        { label: 'Fleet Vehicles', value: fleet.length, icon: icons.fleet, color: '#6366f1', bg: 'linear-gradient(135deg,#eef2ff,#e0e7ff)', border: '#c7d2fe', trend: fleet.length + ' vehicles' },
        { label: 'Trips Assigned', value: trips.length, icon: icons.trip, color: '#10b981', bg: 'linear-gradient(135deg,#ecfdf5,#d1fae5)', border: '#6ee7b7', trend: 'total' },
        { label: 'Action Needed', value: pendingTrips.length, icon: icons.alertCircle, color: '#f59e0b', bg: 'linear-gradient(135deg,#fffbeb,#fef3c7)', border: '#fcd34d', trend: 'pending' },
        { label: 'Scheduled Trips', value: acceptedTrips.length, icon: icons.check, color: '#059669', bg: 'linear-gradient(135deg,#f0fdf4,#dcfce7)', border: '#86efac', trend: 'confirmed' },
        { label: 'Invoices', value: invoices.length, icon: icons.invoice, color: '#0ea5e9', bg: 'linear-gradient(135deg,#f0f9ff,#e0f2fe)', border: '#7dd3fc', trend: 'raised' },
        { label: 'Contracts', value: contracts.length, icon: icons.contracts, color: '#8b5cf6', bg: 'linear-gradient(135deg,#f5f3ff,#ede9fe)', border: '#c4b5fd', trend: 'active' },
    ];

    const chartData = [
        { label: 'Pending', count: pendingTrips.length, color: '#f59e0b' },
        { label: 'Proposed', count: proposedTrips.length, color: '#3b82f6' },
        { label: 'Scheduled', count: acceptedTrips.length, color: '#10b981' },
        { label: 'Rejected', count: rejectedTrips.length, color: '#ef4444' },
    ];
    const maxCount = Math.max(...chartData.map(d => d.count), 1);
    const chartH = 100;

    const statusColor = (vs) => {
        if (vs === 'Accepted') return { bg: '#d1fae5', color: '#065f46' };
        if (vs === 'Vendor Proposed') return { bg: '#dbeafe', color: '#1e40af' };
        if (vs === 'Rejected') return { bg: '#fee2e2', color: '#991b1b' };
        if (vs === 'Pending Vendor' || vs === 'Not Assigned') return { bg: '#fef9c3', color: '#92400e' };
        return { bg: '#f3f4f6', color: '#6b7280' };
    };

    return (
        <div style={{ flex: 1, padding: '32px 40px', fontFamily: FONT, background: '#f1f5f9', minHeight: '100vh', overflowY: 'auto' }}>

            {/* Technical Vendor Banner */}
            <div style={{ background: '#0f172a', padding: '32px 40px', borderRadius: 24, marginBottom: 28, position: 'relative', overflow: 'hidden', border: '1px solid #1e293b' }}>
                <div style={{ position: 'relative', zIndex: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                            <div style={{ background: '#10b981', width: 10, height: 10, borderRadius: '50%', boxShadow: '0 0 12px #10b981' }}></div>
                            <span style={{ color: '#10b981', fontSize: 11, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.1em' }}>Vendor Terminal Active</span>
                        </div>
                        <h1 style={{ fontSize: 34, fontWeight: 900, color: 'white', margin: 0, letterSpacing: '-0.03em' }}>
                            Welcome back, <span style={{ color: '#10b981' }}>{vendor?.contactPerson || 'Partner'}</span>
                        </h1>
                        <p style={{ color: '#94a3b8', margin: '8px 0 0', fontSize: 15, fontWeight: 500 }}>
                            {vendor?.vendorName} · Fleet Operations Control
                        </p>
                    </div>
                    <div style={{ display: 'flex', gap: 16 }}>
                        <div style={{ background: 'rgba(30,41,59,0.5)', border: '1px solid #334155', borderRadius: 16, padding: '16px 24px', textAlign: 'center', minWidth: 120 }}>
                            <div style={{ fontSize: 24, fontWeight: 900, color: 'white' }}>{trips.length}</div>
                            <div style={{ fontSize: 10, color: '#64748b', fontWeight: 800, textTransform: 'uppercase', marginTop: 4 }}>Fleet Load</div>
                        </div>
                        <div style={{ background: 'rgba(30,41,59,0.5)', border: '1px solid #334155', borderRadius: 16, padding: '16px 24px', textAlign: 'center', minWidth: 120 }}>
                            <div style={{ fontSize: 24, fontWeight: 900, color: '#f59e0b' }}>{pendingTrips.length}</div>
                            <div style={{ fontSize: 10, color: '#64748b', fontWeight: 800, textTransform: 'uppercase', marginTop: 4 }}>Alerts</div>
                        </div>
                    </div>
                </div>
                {/* Technical Grid Overlay */}
                <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(#334155 0.5px, transparent 0.5px)', backgroundSize: '24px 24px', opacity: 0.15 }}></div>
            </div>

            {/* Industrial Trip Status Cards */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 16 }}>
                {tripCards.map(c => {
                    const statusColor = c.status === 'Scheduled' ? '#6366f1' : c.status === 'Ongoing' ? '#f59e0b' : '#10b981';
                    return (
                        <div
                            key={c.label}
                            onClick={() => onNavigate(c.status)}
                            style={{
                                background: '#1e293b', padding: '24px', borderRadius: 20, color: 'white', position: 'relative', cursor: 'pointer',
                                border: '1px solid #334155', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', transition: 'all 0.2s ease'
                            }}
                            className="vendor-card-hover"
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <div style={{ fontSize: 10, fontWeight: 800, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: 8 }}>{c.label}</div>
                                    <div style={{ fontSize: 32, fontWeight: 900, color: statusColor, lineHeight: 1 }}>{c.count}</div>
                                </div>
                                <div style={{ background: 'rgba(255,255,255,0.03)', width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid rgba(255,255,255,0.05)' }}>
                                    <Icon d={c.icon} size={24} color={statusColor} />
                                </div>
                            </div>
                            <div style={{ marginTop: 16, height: 2, background: 'rgba(255,255,255,0.05)', borderRadius: 1 }}>
                                <div style={{ height: '100%', width: '40%', background: statusColor, borderRadius: 1, boxShadow: `0 0 8px ${statusColor}` }}></div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Tactical KPI Cards */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: 16, marginBottom: 28 }}>
                {kpis.map(k => (
                    <div key={k.label} style={{ background: 'white', padding: '20px', borderRadius: 20, border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', gap: 12, position: 'relative' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ background: '#f8fafc', width: 40, height: 40, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #f1f5f9' }}>
                                <Icon d={k.icon} size={18} color={k.color} />
                            </div>
                            <div style={{ fontSize: 20, fontWeight: 900, color: '#0f172a' }}>{k.value}</div>
                        </div>
                        <div>
                            <div style={{ fontSize: 12, fontWeight: 700, color: '#64748b' }}>{k.label}</div>
                            <div style={{ fontSize: 9, fontWeight: 800, color: k.color, textTransform: 'uppercase', marginTop: 2 }}>{k.trend}</div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Chart + Recent Trips */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: 20, marginBottom: 20 }}>

                {/* Bar Chart */}
                <div style={{ background: 'white', borderRadius: 18, border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', padding: '22px 24px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
                        <div style={{ width: 32, height: 32, borderRadius: 10, background: '#ecfdf5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Icon d={icons.trip} size={16} color="#059669" />
                        </div>
                        <div>
                            <div style={{ fontSize: 14, fontWeight: 800, color: '#0f172a' }}>Trip Breakdown</div>
                            <div style={{ fontSize: 11, color: '#94a3b8' }}>by status</div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 14, height: chartH + 20, paddingBottom: 20, position: 'relative' }}>
                        {chartData.map(d => {
                            const barH = Math.max(8, (d.count / maxCount) * chartH);
                            return (
                                <div key={d.label} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                                    <div style={{ fontSize: 12, fontWeight: 800, color: d.color }}>{d.count}</div>
                                    <div style={{ width: '100%', height: barH, background: d.color, borderRadius: '6px 6px 0 0', opacity: 0.85 }} />
                                    <div style={{ fontSize: 10, fontWeight: 600, color: '#94a3b8', textAlign: 'center', lineHeight: 1.2 }}>{d.label}</div>
                                </div>
                            );
                        })}
                        <div style={{ position: 'absolute', bottom: 20, left: 0, right: 0, height: 1, background: '#f1f5f9' }} />
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 12, borderTop: '1px solid #f8fafc', paddingTop: 12 }}>
                        {chartData.map(d => (
                            <div key={d.label} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                <div style={{ width: 8, height: 8, borderRadius: 2, background: d.color }} />
                                <span style={{ fontSize: 11, color: '#6b7280', fontWeight: 500 }}>{d.label}: {d.count}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Recent Trips */}
                <div style={{ background: 'white', borderRadius: 18, border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', overflow: 'hidden' }}>
                    <div style={{ padding: '18px 22px', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 32, height: 32, borderRadius: 10, background: '#ecfdf5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Icon d={icons.trip} size={16} color="#059669" />
                        </div>
                        <div>
                            <div style={{ fontSize: 14, fontWeight: 800, color: '#0f172a' }}>Recent Trips</div>
                            <div style={{ fontSize: 11, color: '#94a3b8' }}>Latest assigned trips</div>
                        </div>
                    </div>
                    <div style={{ overflowY: 'auto', maxHeight: 260 }}>
                        {recentTrips.length === 0 ? (
                            <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>No trips yet</div>
                        ) : recentTrips.map((t, i) => {
                            const sc = statusColor(t.vendorStatus);
                            return (
                                <div key={t._id} style={{ padding: '14px 22px', borderBottom: '1px solid #f8fafc', display: 'flex', alignItems: 'center', gap: 14, background: i % 2 === 0 ? 'white' : '#fafafa' }}>
                                    <div style={{ width: 36, height: 36, borderRadius: 10, background: sc.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <Icon d={icons.trip} size={15} color={sc.color} />
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontSize: 13, fontWeight: 700, color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {t.pickupLocation || '—'} → {t.dropLocation || '—'}
                                        </div>
                                        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>
                                            {t.tripDate ? new Date(t.tripDate).toLocaleDateString() : (t.recurringDays?.join(', ') || '—')} · {t.clientId?.companyName || 'No client'}
                                        </div>
                                    </div>
                                    <span style={{ fontSize: 10, fontWeight: 800, padding: '3px 9px', borderRadius: 20, background: sc.bg, color: sc.color, whiteSpace: 'nowrap', flexShrink: 0 }}>
                                        {t.vendorStatus === 'Accepted' ? 'Scheduled' : (t.vendorStatus || 'N/A')}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* Vendor Info Card */}
            <div style={{ background: 'white', borderRadius: 18, border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', overflow: 'hidden' }}>
                <div style={{ padding: '16px 22px', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', gap: 10, background: '#fafbfc' }}>
                    <Icon d={icons.profile} size={16} color="#059669" />
                    <span style={{ fontSize: 13, fontWeight: 800, color: '#0f172a' }}>Vendor Details</span>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))' }}>
                    {[
                        { label: 'Vendor Name', value: vendor?.vendorName, icon: icons.building },
                        { label: 'Contact Person', value: vendor?.contactPerson || '—', icon: icons.profile },
                        { label: 'Email', value: vendor?.email, icon: icons.mail },
                        { label: 'Phone', value: vendor?.phone || '—', icon: icons.phone },
                        { label: 'Category', value: vendor?.category?.name || '—', icon: icons.tag },
                        { label: 'Tax ID', value: vendor?.taxId || '—', icon: icons.tag },
                        { label: 'Address', value: vendor?.address || '—', icon: icons.pin },
                    ].map(f => (
                        <div key={f.label} style={{ padding: '16px 22px', borderRight: '1px solid #f1f5f9', borderBottom: '1px solid #f1f5f9' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 5 }}>
                                <Icon d={f.icon} size={12} color="#10b981" />
                                <span style={{ fontSize: 10, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>{f.label}</span>
                            </div>
                            <div style={{ fontSize: 13.5, fontWeight: 600, color: '#111827' }}>{f.value}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Performance Rating Card */}
            <div style={{ background: 'white', borderRadius: 18, border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', overflow: 'hidden', marginTop: 20 }}>
                <div style={{ padding: '16px 22px', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', gap: 10, background: '#fffbeb' }}>
                    {/* Star icon */}
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                    </svg>
                    <span style={{ fontSize: 13, fontWeight: 800, color: '#0f172a' }}>Performance Rating</span>
                    <span style={{ marginLeft: 'auto', fontSize: 10.5, fontWeight: 700, color: '#92400e', background: '#fef3c7', border: '1px solid #fde68a', padding: '2px 10px', borderRadius: 20 }}>Operator Assessment</span>
                </div>
                <div style={{ padding: '24px 28px' }}>
                    {vendor?.rating ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
                            {/* Stars row */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                <div style={{ display: 'flex', gap: 6 }}>
                                    {[1, 2, 3, 4, 5].map(s => (
                                        <svg key={s} width="28" height="28" viewBox="0 0 24 24"
                                            fill={s <= (vendor.rating || 0) ? '#f59e0b' : 'none'}
                                            stroke={s <= (vendor.rating || 0) ? '#f59e0b' : '#d1d5db'}
                                            strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"
                                            style={{ filter: s <= (vendor.rating || 0) ? 'drop-shadow(0 0 5px rgba(245,158,11,0.45))' : 'none' }}>
                                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                        </svg>
                                    ))}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ fontSize: 22, fontWeight: 900, color: '#d97706', lineHeight: 1 }}>{vendor.rating}<span style={{ fontSize: 14, color: '#94a3b8', fontWeight: 600 }}>/5</span></span>
                                    <span style={{ fontSize: 12, fontWeight: 700, color: '#92400e', marginTop: 2 }}>
                                        {['', 'Poor', 'Fair', 'Good', 'Very Good', 'Excellent'][vendor.rating] || ''}
                                    </span>
                                </div>
                            </div>
                            {/* Remarks */}
                            {vendor?.remarks && (
                                <div style={{ background: '#fffbeb', border: '1.5px solid #fde68a', borderRadius: 12, padding: '14px 18px' }}>
                                    <div style={{ fontSize: 10, fontWeight: 800, color: '#92400e', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 7 }}>Operator Remarks</div>
                                    <div style={{ fontSize: 14, color: '#374151', fontWeight: 500, lineHeight: 1.6, fontStyle: 'italic' }}>"{vendor.remarks}"</div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '8px 0' }}>
                            <div style={{ display: 'flex', gap: 5 }}>
                                {[1, 2, 3, 4, 5].map(s => (
                                    <svg key={s} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                ))}
                            </div>
                            <span style={{ fontSize: 13, color: '#9ca3af', fontWeight: 500 }}>No rating assigned yet by operator</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}




/* Generic table page */
function TablePage({ title, icon, columns, rows, emptyMsg, onAdd, onEdit, onDelete }) {
    return (
        <div style={pg.root}>
            <div style={pg.header}>
                <div>
                    <h1 style={pg.title}>{title}</h1>
                    <p style={pg.sub}>{rows.length} record{rows.length !== 1 ? 's' : ''} found</p>
                </div>
                {onAdd && (
                    <button onClick={onAdd} style={pg.addBtn}>
                        <Icon d={icons.plus} size={15} color="white" /> Add New
                    </button>
                )}
            </div>
            <div style={pg.section}>
                <div style={pg.sectionHeader}><Icon d={icon} size={17} color="#059669" /> {title}</div>
                {rows.length === 0 ? (
                    <div style={{ padding: 48, textAlign: 'center', color: '#9ca3af', fontSize: 14 }}>{emptyMsg}</div>
                ) : (
                    <div style={{ overflowX: 'auto' }}>
                        <table style={pg.table}>
                            <thead>
                                <tr>
                                    {columns.map(c => <th key={c.key} style={pg.th}>{c.label}</th>)}
                                    {(onEdit || onDelete) && <th style={{ ...pg.th, textAlign: 'right' }}>Actions</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, i) => (
                                    <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f9fafb' }}>
                                        {columns.map(c => (
                                            <td key={c.key} style={pg.td}>
                                                {c.render ? c.render(row[c.key], row) : (row[c.key] || '—')}
                                            </td>
                                        ))}
                                        {(onEdit || onDelete) && (
                                            <td style={{ ...pg.td, textAlign: 'right' }}>
                                                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                                    {onEdit && (
                                                        <button onClick={() => onEdit(row)} style={pg.actBtn}>
                                                            <Icon d={icons.edit} size={14} color="#64748b" />
                                                        </button>
                                                    )}
                                                    {onDelete && (
                                                        <button onClick={() => onDelete(row)} style={{ ...pg.actBtn, ':hover': { background: '#fee2e2' } }}>
                                                            <Icon d={icons.trash} size={14} color="#ef4444" />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}

/* Profile */
function ProfilePage({ vendor, onUpdate }) {
    const [edit, setEdit] = useState(false);
    const [form, setForm] = useState({
        contactPerson: vendor?.contactPerson || '',
        phone: vendor?.phone || '',
        address: vendor?.address || '',
        password: vendor?.password || ''
    });

    const handleSave = async (e) => {
        e.preventDefault();
        onUpdate(form);
        setEdit(false);
    };

    return (
        <div style={pg.root}>
            <div style={pg.header}>
                <h1 style={pg.title}>Manage Profile</h1>
                <div style={{ display: 'flex', gap: 12 }}>
                    <button onClick={() => setEdit(!edit)} style={{ ...pg.addBtn, background: edit ? '#94a3b8' : '#10b981' }}>
                        {edit ? 'Cancel' : 'Edit Profile'}
                    </button>
                </div>
            </div>
            <div style={pg.section}>
                <div style={pg.sectionHeader}><Icon d={icons.profile} size={17} color="#059669" /> Account Information</div>
                <div style={{ padding: 24 }}>
                    {!edit ? (
                        <>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 20, marginBottom: 28, paddingBottom: 24, borderBottom: '1px solid #f3f4f6' }}>
                                <div style={{ width: 72, height: 72, borderRadius: 20, background: 'linear-gradient(135deg,#10b981,#059669)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 900, fontSize: 32, boxShadow: '0 8px 24px rgba(16,185,129,0.3)' }}>
                                    {vendor?.vendorName?.charAt(0)?.toUpperCase()}
                                </div>
                                <div>
                                    <div style={{ fontSize: 22, fontWeight: 800, color: '#064e3b' }}>{vendor?.vendorName}</div>
                                    <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>{vendor?.category?.name || 'Vendor'}</div>
                                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 8, padding: '3px 10px', background: '#ecfdf5', borderRadius: 20, fontSize: 12, fontWeight: 700, color: '#065f46', border: '1px solid #6ee7b7' }}>
                                        <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#10b981', display: 'inline-block' }} />
                                        {vendor?.status || 'Active'}
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 20 }}>
                                {[
                                    { label: 'Contact Person', value: vendor?.contactPerson, icon: icons.profile },
                                    { label: 'Email', value: vendor?.email, icon: icons.mail },
                                    { label: 'Phone', value: vendor?.phone, icon: icons.phone },
                                    { label: 'Tax ID', value: vendor?.taxId, icon: icons.tag },
                                    { label: 'Address', value: vendor?.address, icon: icons.pin },
                                ].filter(f => f.label).map(f => (
                                    <div key={f.label} style={{ padding: '14px 16px', background: '#f9fafb', borderRadius: 12, border: '1px solid #f3f4f6' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 6 }}>
                                            <Icon d={f.icon} size={14} color="#10b981" />
                                            <span style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{f.label}</span>
                                        </div>
                                        <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{f.value || '—'}</div>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <form onSubmit={handleSave} style={{ display: 'grid', gap: 16 }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                                <div style={formStyle.group}>
                                    <label style={formStyle.label}>Contact Person</label>
                                    <input style={formStyle.input} value={form.contactPerson} onChange={e => setForm({ ...form, contactPerson: e.target.value })} />
                                </div>
                                <div style={formStyle.group}>
                                    <label style={formStyle.label}>Phone Number</label>
                                    <input style={formStyle.input} value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} />
                                </div>
                            </div>
                            <div style={formStyle.group}>
                                <label style={formStyle.label}>Address</label>
                                <input style={formStyle.input} value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} />
                            </div>
                            <div style={formStyle.group}>
                                <label style={formStyle.label}>Update Password</label>
                                <input type="password" style={formStyle.input} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="Leave blank to keep current" />
                            </div>
                            <button type="submit" style={formStyle.submit}>Save Profile Changes</button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}

const formStyle = {
    group: { display: 'flex', flexDirection: 'column', gap: 6 },
    label: { fontSize: 12, fontWeight: 700, color: '#4b5563', textTransform: 'uppercase', letterSpacing: '0.03em' },
    input: { padding: '10px 14px', borderRadius: 8, border: '1px solid #d1d5db', fontSize: 14, outline: 'none' },
    submit: { background: '#10b981', color: 'white', border: 'none', padding: '12px', borderRadius: 8, fontWeight: 700, cursor: 'pointer', marginTop: 10 }
};

const pg = {
    root: { flex: 1, padding: '36px 44px', fontFamily: FONT, background: '#f8fafc', minHeight: '100vh' },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 32 },
    title: { fontSize: 26, fontWeight: 900, color: '#0f172a', margin: 0, letterSpacing: '-0.03em' },
    sub: { fontSize: 14, color: '#64748b', margin: '7px 0 0', fontWeight: 500 },
    statusPill: { display: 'flex', alignItems: 'center', gap: 7, padding: '7px 16px', background: '#ecfdf5', borderRadius: 24, fontSize: 12.5, fontWeight: 700, color: '#065f46', border: '1px solid #a7f3d0' },
    addBtn: { background: 'linear-gradient(135deg,#10b981,#059669)', color: 'white', border: 'none', borderRadius: 12, padding: '10px 20px', fontSize: 13, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, boxShadow: '0 4px 16px rgba(16,185,129,0.3)', letterSpacing: '-0.01em' },
    actBtn: { background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 8, width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
    statCard: { padding: '22px 22px 18px', borderRadius: 18, boxShadow: '0 2px 8px rgba(0,0,0,0.05)', border: '1px solid rgba(0,0,0,0.04)' },
    section: { background: '#fff', borderRadius: 18, border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', overflow: 'hidden' },
    sectionHeader: { display: 'flex', alignItems: 'center', gap: 9, padding: '16px 22px', borderBottom: '1px solid #f1f5f9', fontSize: 13, fontWeight: 800, color: '#0f172a', background: '#fafbfc' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { padding: '13px 18px', fontSize: 10.5, fontWeight: 800, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.07em', textAlign: 'left', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' },
    td: { padding: '15px 18px', fontSize: 13.5, color: '#334155', fontWeight: 500, borderBottom: '1px solid #f1f5f9' },
};

/* ─────────────────────── MODAL ───────────────────────── */
function Modal({ title, children, onClose, onSave, loading }) {
    return (
        <div style={md.overlay} onClick={onClose}>
            <div style={md.content} onClick={e => e.stopPropagation()}>
                <div style={md.header}>
                    <div style={md.title}>{title}</div>
                    <button onClick={onClose} style={md.close}><Icon d={icons.x} size={20} color="#94a3b8" /></button>
                </div>
                <div style={md.body}>{children}</div>
                <div style={md.footer}>
                    <button onClick={onClose} style={md.cancelBtn}>Cancel</button>
                    <button onClick={onSave} disabled={loading} style={md.saveBtn}>
                        {loading ? 'Saving...' : 'Save Changes'}
                    </button>
                </div>
            </div>
        </div>
    );
}

const md = {
    overlay: { position: 'fixed', inset: 0, background: 'rgba(2,6,23,0.55)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
    content: { background: 'white', borderRadius: 22, width: '100%', maxWidth: 520, boxShadow: '0 32px 64px -12px rgba(0,0,0,0.35)', fontFamily: FONT },
    header: { padding: '22px 26px 18px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    title: { fontSize: 19, fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em' },
    close: { background: '#f1f5f9', border: 'none', cursor: 'pointer', padding: 8, borderRadius: 9, display: 'flex' },
    body: { padding: '22px 26px', maxHeight: '68vh', overflowY: 'auto' },
    footer: { padding: '16px 26px', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'flex-end', gap: 10 },
    cancelBtn: { padding: '10px 22px', border: '1px solid #e2e8f0', background: '#f8fafc', borderRadius: 11, fontSize: 13.5, fontWeight: 600, color: '#64748b', cursor: 'pointer', fontFamily: FONT },
    saveBtn: { padding: '10px 26px', border: 'none', background: 'linear-gradient(135deg,#10b981,#059669)', color: 'white', borderRadius: 11, fontSize: 13.5, fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 14px rgba(16,185,129,0.3)', fontFamily: FONT },
};

/* ─────────────────────── VENDOR TRIPS PAGE ─────────────────────── */
function VendorTripsPage({ trips, fleet, drivers, vendorId, operatorId, onRefresh, showToast, initialFilter }) {
    const [respondModal, setRespondModal] = useState(null); // trip being responded to
    const [proposal, setProposal] = useState({ vehicleId: '', driverId: '', amount: '' });
    const [submitting, setSubmitting] = useState(false);

    const [filter, setFilter] = useState(initialFilter || 'All');

    useEffect(() => {
        if (initialFilter) setFilter(initialFilter);
    }, [initialFilter]);

    const statusConfig = {
        'Not Assigned': { bg: '#f3f4f6', color: '#6b7280', label: 'Not Assigned' },
        'Pending Vendor': { bg: '#fef9c3', color: '#92400e', label: 'Awaiting Your Response' },
        'Vendor Proposed': { bg: '#dbeafe', color: '#1e40af', label: 'Proposal Sent' },
        'Accepted': { bg: '#d1fae5', color: '#065f46', label: 'Scheduled' },
        'Rejected': { bg: '#fee2e2', color: '#991b1b', label: 'Rejected' },
    };

    const openRespond = (trip) => {
        setProposal({ vehicleId: '', driverId: '', amount: trip.vendorProposedAmount || '' });
        setRespondModal(trip);
    };

    const submitProposal = async () => {
        if (!proposal.vehicleId || !proposal.driverId || !proposal.amount) {
            showToast('Please select fleet, driver and enter amount', 'error');
            return;
        }
        setSubmitting(true);
        try {
            const res = await fetch(`/api/trips/${respondModal._id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    vendorProposedVehicleId: proposal.vehicleId,
                    vendorProposedDriverId: proposal.driverId,
                    vendorProposedAmount: Number(proposal.amount),
                    vendorStatus: 'Vendor Proposed',
                }),
            });
            if (!res.ok) throw new Error('Failed to submit proposal');
            showToast('Proposal submitted successfully! Waiting for operator confirmation.');
            setRespondModal(null);
            onRefresh();
        } catch (err) {
            showToast(err.message, 'error');
        } finally {
            setSubmitting(false);
        }
    };

    const filteredTrips = trips.filter(t => {
        if (filter === 'All') return true;
        if (filter === 'Scheduled') return t.vendorStatus === 'Accepted' && (t.status === 'Scheduled' || t.status === 'Requested');
        if (filter === 'Ongoing') return t.status === 'Ongoing' || t.status === 'In Progress';
        return t.status === filter;
    });

    const pendingTrips = filteredTrips.filter(t => t.vendorStatus === 'Pending Vendor' || t.vendorStatus === 'Not Assigned');
    const otherTrips = filteredTrips.filter(t => t.vendorStatus !== 'Pending Vendor' && t.vendorStatus !== 'Not Assigned');

    return (
        <div style={pg.root}>
            <div style={pg.header}>
                <div>
                    <h1 style={pg.title}>My Trips</h1>
                    <p style={pg.sub}>{filteredTrips.length} trip{filteredTrips.length !== 1 ? 's' : ''} {filter !== 'All' ? `(${filter})` : ''} assigned to your account</p>
                </div>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: 8, background: '#fff', padding: '4px', borderRadius: 12, border: '1.5px solid #e2e8f0' }}>
                        {['All', 'Scheduled', 'Ongoing', 'Completed'].map(f => (
                            <button
                                key={f}
                                onClick={() => setFilter(f)}
                                style={{
                                    padding: '6px 14px', borderRadius: 8, border: 'none', fontSize: 12, fontWeight: 700, cursor: 'pointer',
                                    background: filter === f ? '#10b981' : 'transparent',
                                    color: filter === f ? 'white' : '#64748b',
                                    transition: 'all 0.2s'
                                }}
                            >
                                {f}
                            </button>
                        ))}
                    </div>
                    {pendingTrips.length > 0 && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 16px', background: '#fef9c3', border: '1.5px solid #fcd34d', borderRadius: 10 }}>
                            <Icon d={icons.alertCircle} size={16} color="#92400e" />
                            <span style={{ fontSize: 13, fontWeight: 700, color: '#92400e' }}>{pendingTrips.length} Action Needed</span>
                        </div>
                    )}
                </div>
            </div>

            {/* Pending trips — action required */}
            {pendingTrips.length > 0 && (
                <div style={{ marginBottom: 28 }}>
                    <div style={{ fontSize: 12, fontWeight: 800, color: '#92400e', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 12 }}>⚡ Action Required</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                        {pendingTrips.map(t => (
                            <div key={t._id} style={{ background: 'white', borderRadius: 16, border: '2px solid #fcd34d', boxShadow: '0 4px 16px rgba(251,191,36,0.15)', padding: '20px 24px', display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                                        <span style={{ padding: '3px 12px', borderRadius: 20, fontSize: 11, fontWeight: 800, background: '#fef9c3', color: '#92400e' }}>PENDING RESPONSE</span>
                                        <span style={{ fontSize: 12, color: '#9ca3af' }}>{t.tripDate ? new Date(t.tripDate).toLocaleDateString() : t.recurringDays?.join(', ') || '—'}</span>
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px 24px' }}>
                                        <div>
                                            <div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase' }}>From</div>
                                            <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{t.pickupLocation}</div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase' }}>To</div>
                                            <div style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{t.dropLocation}</div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase' }}>Type</div>
                                            <div style={{ fontSize: 13, color: '#374151' }}>{t.tripType} · {t.tripFrequency}</div>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase' }}>Client</div>
                                            <div style={{ fontSize: 13, color: '#374151' }}>{t.clientId?.companyName || '—'}</div>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    onClick={() => openRespond(t)}
                                    style={{ background: 'linear-gradient(135deg,#10b981,#059669)', color: 'white', border: 'none', borderRadius: 10, padding: '12px 24px', fontWeight: 800, fontSize: 14, cursor: 'pointer', boxShadow: '0 4px 12px rgba(16,185,129,0.3)', display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}
                                >
                                    <Icon d={icons.send} size={15} color="white" /> Respond to Trip
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Other trips */}
            {otherTrips.length > 0 && (
                <div style={pg.section}>
                    <div style={pg.sectionHeader}><Icon d={icons.trip} size={17} color="#059669" /> All Trips</div>
                    <div style={{ overflowX: 'auto' }}>
                        <table style={pg.table}>
                            <thead>
                                <tr>
                                    {['Date', 'Route', 'Type', 'Client', 'Your Fleet', 'Your Driver', 'Amount', 'Status'].map(h => (
                                        <th key={h} style={pg.th}>{h}</th>
                                    ))}
                                    <th style={{ ...pg.th, textAlign: 'right' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {otherTrips.map((t, i) => {
                                    const sc = statusConfig[t.vendorStatus] || statusConfig['Not Assigned'];
                                    return (
                                        <tr key={t._id} style={{ background: i % 2 === 0 ? '#fff' : '#f9fafb' }}>
                                            <td style={pg.td}>{t.tripDate ? new Date(t.tripDate).toLocaleDateString() : t.recurringDays?.join(', ') || '—'}</td>
                                            <td style={pg.td}>
                                                <div style={{ fontWeight: 600 }}>{t.pickupLocation}</div>
                                                <div style={{ fontSize: 11, color: '#6b7280' }}>→ {t.dropLocation}</div>
                                            </td>
                                            <td style={pg.td}>{t.tripType}</td>
                                            <td style={pg.td}>{t.clientId?.companyName || '—'}</td>
                                            <td style={pg.td}>{t.vendorProposedVehicleId?.registrationNumber || '—'}</td>
                                            <td style={pg.td}>{t.vendorProposedDriverId?.name || '—'}</td>
                                            <td style={pg.td}>{t.vendorProposedAmount ? t.vendorProposedAmount.toLocaleString() : '—'}</td>
                                            <td style={pg.td}>
                                                <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: sc.bg, color: sc.color }}>
                                                    {sc.label}
                                                </span>
                                            </td>
                                            <td style={{ ...pg.td, textAlign: 'right' }}>
                                                {t.vendorStatus === 'Rejected' && (
                                                    <button onClick={() => openRespond(t)} style={{ fontSize: 11, fontWeight: 700, color: '#10b981', background: '#ecfdf5', border: '1px solid #6ee7b7', borderRadius: 6, padding: '4px 10px', cursor: 'pointer' }}>Resubmit</button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {trips.length === 0 && (
                <div style={{ ...pg.section, padding: 48, textAlign: 'center', color: '#9ca3af', fontSize: 14 }}>
                    No trips assigned to your account yet. You will be notified when an operator assigns a trip to you.
                </div>
            )}

            {/* Respond Modal */}
            {respondModal && (
                <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                    <div style={{ background: 'white', borderRadius: 20, width: '100%', maxWidth: 520, boxShadow: '0 25px 50px rgba(0,0,0,0.25)', overflow: 'hidden' }}>
                        <div style={{ padding: '20px 24px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'linear-gradient(135deg,#ecfdf5,#f0fdf4)' }}>
                            <div>
                                <div style={{ fontSize: 18, fontWeight: 800, color: '#064e3b' }}>Respond to Trip</div>
                                <div style={{ fontSize: 13, color: '#6b7280', marginTop: 2 }}>{respondModal.pickupLocation} → {respondModal.dropLocation}</div>
                            </div>
                            <button onClick={() => setRespondModal(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}><Icon d={icons.x} size={22} color="#6b7280" /></button>
                        </div>
                        <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
                            <div style={formStyle.group}>
                                <label style={formStyle.label}>Assign Fleet Vehicle *</label>
                                <select style={{ ...formStyle.input, height: 44 }} value={proposal.vehicleId} onChange={e => setProposal({ ...proposal, vehicleId: e.target.value })}>
                                    <option value="">Select Vehicle</option>
                                    {fleet.map(v => <option key={v._id} value={v._id}>{v.registrationNumber} — {v.vehicleType} {v.make} {v.model}</option>)}
                                </select>
                            </div>
                            <div style={formStyle.group}>
                                <label style={formStyle.label}>Assign Driver *</label>
                                <select style={{ ...formStyle.input, height: 44 }} value={proposal.driverId} onChange={e => setProposal({ ...proposal, driverId: e.target.value })}>
                                    <option value="">Select Driver</option>
                                    {drivers.map(d => <option key={d._id} value={d._id}>{d.name} {d.phoneNumber ? `· ${d.phoneNumber}` : ''}</option>)}
                                </select>
                            </div>
                            <div style={formStyle.group}>
                                <label style={formStyle.label}>Your Price / Amount *</label>
                                <input type="number" placeholder="Enter amount" style={{ ...formStyle.input, height: 44 }} value={proposal.amount} onChange={e => setProposal({ ...proposal, amount: e.target.value })} />
                            </div>
                            <div style={{ background: '#f0fdf4', borderRadius: 10, border: '1px solid #bbf7d0', padding: 12, fontSize: 12, color: '#065f46', lineHeight: 1.5 }}>
                                💡 Once submitted, the operator will review your proposal and either accept or reject it. You'll be notified of their decision.
                            </div>
                        </div>
                        <div style={{ padding: '16px 24px', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                            <button onClick={() => setRespondModal(null)} style={{ padding: '10px 20px', border: '1px solid #e2e8f0', background: 'white', borderRadius: 10, fontSize: 14, fontWeight: 600, color: '#64748b', cursor: 'pointer' }}>Cancel</button>
                            <button onClick={submitProposal} disabled={submitting} style={{ padding: '10px 24px', border: 'none', background: 'linear-gradient(135deg,#10b981,#059669)', color: 'white', borderRadius: 10, fontSize: 14, fontWeight: 800, cursor: 'pointer', boxShadow: '0 4px 12px rgba(16,185,129,0.3)', display: 'flex', alignItems: 'center', gap: 8 }}>
                                <Icon d={icons.send} size={14} color="white" />
                                {submitting ? 'Submitting...' : 'Submit Proposal'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

/* ─────────────────────── MAIN PORTAL ─────────────────────── */
export default function VendorPortal({ vendor: initialVendor, onLogout, operatorDetails }) {
    const [activePage, setActivePage] = useState('overview');
    const [tripStatusFilter, setTripStatusFilter] = useState('All');
    const [vendorData, setVendorData] = useState(initialVendor); // fresh copy with rating/remarks
    const [fleet, setFleet] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [docs, setDocs] = useState([]);
    const [contracts, setContracts] = useState([]);
    const [pricing, setPricing] = useState([]);
    const [trips, setTrips] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [quotations, setQuotations] = useState([]);
    const [masterData, setMasterData] = useState({});
    const [loading, setLoading] = useState(true);
    const [notifications, setNotifications] = useState([]);

    const [modal, setModal] = useState({ show: false, type: '', data: null });
    const [driverEditData, setDriverEditData] = useState(null);
    const [saving, setSaving] = useState(false);
    const [toast, setToast] = useState(null);

    const vendorId = initialVendor?._id;
    const operatorId = initialVendor?.operatorId;

    const showToast = (msg, type = 'success') => {
        setToast({ msg, type });
        setTimeout(() => setToast(null), 3000);
    };

    const loadData = useCallback(async () => {
        if (!vendorId || !operatorId) return;
        setLoading(true);
        try {
            const [fleetRes, driversRes, docsRes, contractsRes, pricingRes, tripsRes, invoicesRes, quotesRes, masterRes, notifRes, vendorsRes] = await Promise.all([
                fetch(`${API}/vendor-fleet/${operatorId}`),
                fetch(`${API}/drivers/${operatorId}`),
                fetch(`${API}/vendor-documents/${operatorId}`),
                fetch(`${API}/vendor-contracts/${operatorId}`),
                fetch(`${API}/vendor-pricing/${operatorId}`),
                fetch(`${API}/trips/${operatorId}`),
                fetch(`${API}/invoices/${operatorId}`),
                fetch(`${API}/quotations/${operatorId}`),
                fetch(`${API}/master-data`),
                fetch(`${API}/notifications/vendor/${vendorId}`),
                fetch(`${API}/vendors/${operatorId}`),
            ]);
            const [fleetData, driversData, docsData, contractsData, pricingData, tripsData, invoicesData, quotesData, mData, notifData, vendorsData] = await Promise.all([
                fleetRes.json(), driversRes.json(), docsRes.json(), contractsRes.json(), pricingRes.json(),
                tripsRes.json(), invoicesRes.json(), quotesRes.json(), masterRes.json(), notifRes.json(), vendorsRes.json()
            ]);
            // Pick fresh vendor record to get latest rating/remarks
            if (Array.isArray(vendorsData)) {
                const fresh = vendorsData.find(v => String(v._id) === String(vendorId));
                if (fresh) setVendorData(fresh);
            }

            // Group master data
            const masterMap = {};
            if (Array.isArray(mData)) {
                mData.forEach(m => {
                    if (!masterMap[m.category]) masterMap[m.category] = [];
                    masterMap[m.category].push(m);
                });
            }
            setMasterData(masterMap);

            setFleet(Array.isArray(fleetData) ? fleetData.filter(f => String(f.vendorId?._id || f.vendorId) === String(vendorId)) : []);
            setDrivers(Array.isArray(driversData) ? driversData.filter(d => String(d.vendorId?._id || d.vendorId) === String(vendorId)) : []);
            setDocs(Array.isArray(docsData) ? docsData.filter(d => String(d.vendorId?._id || d.vendorId) === String(vendorId)) : []);
            setContracts(Array.isArray(contractsData) ? contractsData.filter(c => String(c.vendorId?._id || c.vendorId) === String(vendorId)) : []);
            setPricing(Array.isArray(pricingData) ? pricingData.filter(p => String(p.vendorId?._id || p.vendorId) === String(vendorId)) : []);
            setTrips(Array.isArray(tripsData) ? tripsData.filter(t => String(t.vendorId?._id || t.vendorId) === String(vendorId)) : []);
            setInvoices(Array.isArray(invoicesData) ? invoicesData.filter(i => String(i.vendorId?._id || i.vendorId) === String(vendorId)) : []);
            setQuotations(Array.isArray(quotesData) ? quotesData.filter(q => String(q.vendorId?._id || q.vendorId) === String(vendorId)) : []);
            setNotifications(Array.isArray(notifData) ? notifData : []);
        } catch (err) {
            console.error('Vendor portal data load error:', err);
        } finally {
            setLoading(false);
        }
    }, [vendorId, operatorId]);

    useEffect(() => { loadData(); }, [loadData]);

    const handleAction = (type, data = null) => {
        setModal({ show: true, type, data: data || getDefaultData(type) });
    };

    const getDefaultData = (type) => {
        switch (type) {
            case 'fleet': return { vehicleType: '', registrationNumber: '', make: '', model: '', year: new Date().getFullYear(), fuelType: '', color: '', purchasePrice: '', acquisitionDate: '', depreciationMonthly: '', gpsMonthly: '', dashcamMonthly: '', insuranceMonthly: '', otherCostsMonthly: '', status: 'Under Review' };
            case 'drivers': return { name: '', email: '', phoneNumber: '', status: 'Under Review' };
            case 'docs': return { documentType: '', description: '', expiryDate: '', status: 'Under Review' };
            case 'contracts': return { contractType: '', startDate: '', endDate: '', value: 0, status: 'Under Review' };
            case 'pricing': return { serviceType: '', rateType: '', rate: 0, currency: 'USD', notes: '' };
            default: return {};
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            const isEdit = modal.data._id;
            let url = '';
            let method = isEdit ? 'PUT' : 'POST';

            switch (modal.type) {
                case 'fleet': url = `/api/vendor-fleet${isEdit ? '/' + modal.data._id : ''}`; break;
                case 'drivers': url = `/api/drivers${isEdit ? '/' + modal.data._id : ''}`; break;
                case 'docs': url = `/api/vendor-documents${isEdit ? '/' + modal.data._id : ''}`; break;
                case 'contracts': url = `/api/vendor-contracts${isEdit ? '/' + modal.data._id : ''}`; break;
                case 'pricing': url = `/api/vendor-pricing${isEdit ? '/' + modal.data._id : ''}`; break;
                default: break;
            }

            const payload = { ...modal.data, vendorId, operatorId };
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            if (!res.ok) throw new Error('Failed to save');
            showToast('Changes saved successfully');
            setModal({ show: false, type: '', data: null });
            loadData();
        } catch (err) {
            showToast(err.message, 'error');
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async (type, item) => {
        if (!window.confirm('Are you sure you want to delete this record?')) return;
        try {
            let url = '';
            switch (type) {
                case 'fleet': url = `/api/vendor-fleet/${item._id}`; break;
                case 'docs': url = `/api/vendor-documents/${item._id}`; break;
                case 'contracts': url = `/api/vendor-contracts/${item._id}`; break;
                case 'pricing': url = `/api/vendor-pricing/${item._id}`; break;
                default: break;
            }
            const res = await fetch(url, { method: 'DELETE' });
            if (!res.ok) throw new Error('Delete failed');
            showToast('Record deleted successfully');
            loadData();
        } catch (err) {
            showToast(err.message, 'error');
        }
    };

    const handleProfileUpdate = async (formData) => {
        try {
            const res = await fetch(`/api/vendors/${vendorId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            if (!res.ok) throw new Error('Update failed');
            showToast('Profile updated successfully');
            // We should ideally update initialVendor here, but since it's a prop, 
            // the parent App should refresh if we want it perfect. 
            // For now, refreshing the page is a simple fallback or just trust the local state would be better.
            window.location.reload();
        } catch (err) {
            showToast(err.message, 'error');
        }
    };

    const renderPage = () => {
        if (loading) return (
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10b981', fontSize: 16, fontFamily: 'Inter,sans-serif' }}>
                Loading…
            </div>
        );
        switch (activePage) {
            case 'overview':
                return <OverviewPage
                    vendor={vendorData}
                    fleet={fleet}
                    docs={docs}
                    contracts={contracts}
                    pricing={pricing}
                    trips={trips}
                    invoices={invoices}
                    quotations={quotations}
                    operatorDetails={operatorDetails}
                    onNavigate={(status) => {
                        setTripStatusFilter(status);
                        setActivePage('trips');
                    }}
                />;
            case 'trips':
                return <VendorTripsPage
                    trips={trips}
                    fleet={fleet}
                    drivers={drivers}
                    vendorId={vendorId}
                    operatorId={operatorId}
                    onRefresh={loadData}
                    showToast={showToast}
                    initialFilter={tripStatusFilter}
                />;
            case 'invoices':
                return <TablePage
                    title="Vendor Invoices"
                    icon={icons.invoice}
                    emptyMsg="No invoices found."
                    columns={[
                        { key: 'invoiceNumber', label: 'Invoice #' },
                        { key: 'issueDate', label: 'Date', render: v => v ? new Date(v).toLocaleDateString() : '—' },
                        { key: 'dueDate', label: 'Due Date', render: v => v ? new Date(v).toLocaleDateString() : '—' },
                        { key: 'totalAmount', label: 'Amount', render: v => v ? `${Number(v).toLocaleString()}` : '—' },
                        { key: 'status', label: 'Status' },
                    ]}
                    rows={invoices}
                />;
            case 'quotations':
                return <TablePage
                    title="Vendor Quotations"
                    icon={icons.quote}
                    emptyMsg="No quotations found."
                    columns={[
                        { key: 'quotationNumber', label: 'Quote #' },
                        { key: 'issueDate', label: 'Date', render: v => v ? new Date(v).toLocaleDateString() : '—' },
                        { key: 'validUntil', label: 'Expiry', render: v => v ? new Date(v).toLocaleDateString() : '—' },
                        { key: 'totalAmount', label: 'Amount', render: v => v ? `${Number(v).toLocaleString()}` : '—' },
                        { key: 'status', label: 'Status' },
                    ]}
                    rows={quotations}
                />;
            case 'fleet':
                return <TablePage
                    title="Manage Fleet"
                    icon={icons.fleet}
                    emptyMsg="No fleet vehicles assigned to your account yet."
                    onAdd={() => handleAction('fleet')}
                    onEdit={(row) => handleAction('fleet', row)}
                    onDelete={(row) => handleDelete('fleet', row)}
                    columns={[
                        { key: 'vehicleType', label: 'Type' },
                        { key: 'registrationNumber', label: 'Plate No.' },
                        { key: 'make', label: 'Make' },
                        { key: 'model', label: 'Model' },
                        { key: 'year', label: 'Year' },
                        { key: 'fuelType', label: 'Fuel' },
                        {
                            key: 'color', label: 'Color', render: (v) => v ? (
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                    <span style={{ width: 12, height: 12, borderRadius: '50%', background: v, border: '1px solid #e2e8f0', display: 'inline-block' }} />
                                    {v}
                                </span>
                            ) : '—'
                        },
                        {
                            key: 'status', label: 'Status', render: v => {
                                const cfg = {
                                    'Active': { bg: '#ecfdf5', color: '#065f46' },
                                    'Under Review': { bg: '#fef9c3', color: '#92400e' },
                                    'Inactive': { bg: '#f1f5f9', color: '#475569' },
                                    'Under Maintenance': { bg: '#dbeafe', color: '#1e40af' },
                                    'Damaged': { bg: '#fee2e2', color: '#991b1b' },
                                    'Retired': { bg: '#f3f4f6', color: '#6b7280' },
                                    'In Transit': { bg: '#fef3c7', color: '#92400e' },
                                }[v] || { bg: '#f1f5f9', color: '#475569' };
                                return <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: cfg.bg, color: cfg.color }}>{v || 'Under Review'}</span>;
                            }
                        },
                    ]}
                    rows={fleet}
                />;
            case 'drivers':
                return <TablePage
                    title="Manage Drivers"
                    icon={icons.drivers}
                    emptyMsg="No drivers registered under your account yet."
                    onAdd={() => { setDriverEditData(null); setActivePage('create-driver'); }}
                    onEdit={(row) => { setDriverEditData(row); setActivePage('create-driver'); }}
                    onDelete={(row) => handleDelete('drivers', row)}
                    columns={[
                        { key: 'name', label: 'Name' },
                        { key: 'phoneNumber', label: 'Phone' },
                        { key: 'email', label: 'Email' },
                        {
                            key: 'status', label: 'Status', render: v => (
                                <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: v === 'Active' ? '#ecfdf5' : '#fef9c3', color: v === 'Active' ? '#065f46' : '#92400e' }}>{v || 'Active'}</span>
                            )
                        },
                    ]}
                    rows={drivers}
                />;
            case 'create-driver':
                return (
                    <div style={{ padding: '0px 0px', flex: 1, overflowY: 'auto' }}>
                        <CreateDriver
                            user={{ userType: 'vendor', _id: initialVendor._id, operatorId: operatorDetails._id }}
                            editDriver={driverEditData}
                            onBack={() => setActivePage('drivers')}
                            onSaved={() => { setActivePage('drivers'); loadData(); }}
                            operatorDetails={operatorDetails}
                            vendorOnly={true}
                        />
                    </div>
                );
            case 'documents':
                return <TablePage
                    title="Documents"
                    icon={icons.docs}
                    emptyMsg="No documents uploaded yet."
                    onAdd={() => handleAction('docs')}
                    onEdit={(row) => handleAction('docs', row)}
                    onDelete={(row) => handleDelete('docs', row)}
                    columns={[
                        { key: 'documentType', label: 'Type' },
                        { key: 'description', label: 'Description' },
                        { key: 'expiryDate', label: 'Expiry', render: v => v ? new Date(v).toLocaleDateString() : '—' },
                        {
                            key: 'status', label: 'Status', render: v => (
                                <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: v === 'Valid' ? '#ecfdf5' : v === 'Under Review' ? '#fef9c3' : '#fef2f2', color: v === 'Valid' ? '#065f46' : v === 'Under Review' ? '#92400e' : '#dc2626' }}>{v || '—'}</span>
                            )
                        },
                    ]}
                    rows={docs}
                />;
            case 'contracts':
                return <TablePage
                    title="Contracts"
                    icon={icons.contracts}
                    emptyMsg="No contracts found for your account."
                    onAdd={() => handleAction('contracts')}
                    onEdit={(row) => handleAction('contracts', row)}
                    onDelete={(row) => handleDelete('contracts', row)}
                    columns={[
                        { key: 'contractType', label: 'Type' },
                        { key: 'startDate', label: 'Start', render: v => v ? new Date(v).toLocaleDateString() : '—' },
                        { key: 'endDate', label: 'End', render: v => v ? new Date(v).toLocaleDateString() : '—' },
                        { key: 'value', label: 'Value', render: v => v ? `${Number(v).toLocaleString()}` : '—' },
                        {
                            key: 'status', label: 'Status', render: v => (
                                <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: v === 'Active' ? '#ecfdf5' : v === 'Under Review' ? '#fef9c3' : '#f1f5f9', color: v === 'Active' ? '#065f46' : v === 'Under Review' ? '#92400e' : '#475569' }}>{v || '—'}</span>
                            )
                        },
                    ]}
                    rows={contracts}
                />;
            case 'pricing':
                return <TablePage
                    title="Manage Pricing"
                    icon={icons.pricing}
                    emptyMsg="No pricing rates configured yet."
                    onAdd={() => handleAction('pricing')}
                    onEdit={(row) => handleAction('pricing', row)}
                    onDelete={(row) => handleDelete('pricing', row)}
                    columns={[
                        { key: 'serviceType', label: 'Service' },
                        { key: 'rateType', label: 'Rate Type' },
                        { key: 'rate', label: 'Rate', render: v => v ? Number(v).toLocaleString() : '—' },
                        { key: 'currency', label: 'Currency' },
                    ]}
                    rows={pricing}
                />;
            case 'profile':
                return <ProfilePage vendor={vendorData} onUpdate={handleProfileUpdate} />;
            default:
                return null;
        }
    };

    return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: '#f1f5f9', fontFamily: FONT }}>
            <VendorSidebar
                activePage={activePage}
                onNavigate={setActivePage}
                vendor={vendorData}
                onLogout={onLogout}
                operatorDetails={operatorDetails}
                badges={{ pendingTrips: trips.filter(t => t.vendorStatus === 'Pending Vendor').length }}
                notifications={notifications}
                onMarkAllRead={async () => {
                    await fetch(`/api/notifications/mark-all-read/vendor/${vendorId}`, { method: 'PUT' });
                    setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
                }}
            />
            <main style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
                {renderPage()}
            </main>

            {modal.show && (
                <Modal
                    title={`${modal.data?._id ? 'Edit' : 'Add'} ${modal.type.charAt(0).toUpperCase() + modal.type.slice(1)}`}
                    onClose={() => setModal({ show: false, type: '', data: null })}
                    onSave={handleSave}
                    loading={saving}
                >
                    <div style={{ display: 'grid', gap: 16 }}>
                        {modal.type === 'fleet' && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                                {/* Identification */}
                                <div style={{ fontSize: 11, fontWeight: 800, color: '#6366f1', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 12, paddingBottom: 6, borderBottom: '1.5px solid #e0e7ff' }}>Vehicle Identification</div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
                                    <div style={{ gridColumn: 'span 2', ...formStyle.group }}>
                                        <label style={formStyle.label}>Vehicle Type</label>
                                        <select style={formStyle.input} value={modal.data.vehicleType} onChange={e => setModal({ ...modal, data: { ...modal.data, vehicleType: e.target.value } })}>
                                            <option value="">Select Type</option>
                                            {(masterData['vehicle-types'] || []).map(m => <option key={m._id} value={m.name}>{m.name}</option>)}
                                        </select>
                                    </div>
                                    <div style={{ gridColumn: 'span 2', ...formStyle.group }}>
                                        <label style={formStyle.label}>Registration Number</label>
                                        <input style={formStyle.input} placeholder="e.g. DXB-12345" value={modal.data.registrationNumber} onChange={e => setModal({ ...modal, data: { ...modal.data, registrationNumber: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Make</label>
                                        <input style={formStyle.input} placeholder="e.g. Toyota" value={modal.data.make} onChange={e => setModal({ ...modal, data: { ...modal.data, make: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Model</label>
                                        <input style={formStyle.input} placeholder="e.g. Hiace" value={modal.data.model} onChange={e => setModal({ ...modal, data: { ...modal.data, model: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Year</label>
                                        <input style={formStyle.input} type="number" min="1990" max={new Date().getFullYear() + 1} placeholder={new Date().getFullYear()} value={modal.data.year || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, year: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Fuel Type</label>
                                        <select style={formStyle.input} value={modal.data.fuelType || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, fuelType: e.target.value } })}>
                                            <option value="">Select fuel type</option>
                                            <option>Petrol</option>
                                            <option>Diesel</option>
                                            <option>Electric</option>
                                            <option>Hybrid</option>
                                            <option>CNG</option>
                                            <option>LPG</option>
                                        </select>
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Color</label>
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                            <input type="color" value={modal.data.color || '#ffffff'} onChange={e => setModal({ ...modal, data: { ...modal.data, color: e.target.value } })} style={{ width: 40, height: 40, border: '1.5px solid #d1d5db', borderRadius: 8, cursor: 'pointer', padding: 2 }} />
                                            <input style={{ ...formStyle.input, flex: 1 }} placeholder="e.g. White" value={modal.data.color || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, color: e.target.value } })} />
                                        </div>
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Status</label>
                                        <select style={formStyle.input} value={modal.data.status || 'Under Review'} onChange={e => setModal({ ...modal, data: { ...modal.data, status: e.target.value } })}>
                                            <option value="Under Review">Under Review</option>
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>
                                            <option value="Under Maintenance">Under Maintenance</option>
                                            <option value="Damaged">Damaged</option>
                                            <option value="Retired">Retired</option>
                                            <option value="In Transit">In Transit</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Financial Details */}
                                <div style={{ fontSize: 11, fontWeight: 800, color: '#6366f1', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 12, paddingBottom: 6, borderBottom: '1.5px solid #e0e7ff', marginTop: 8 }}>Financial Details</div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Purchase Price</label>
                                        <input style={formStyle.input} type="number" step="0.01" placeholder="0.00" value={modal.data.purchasePrice || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, purchasePrice: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Acquisition Date</label>
                                        <input style={formStyle.input} type="date" value={modal.data.acquisitionDate ? modal.data.acquisitionDate.slice(0, 10) : ''} onChange={e => setModal({ ...modal, data: { ...modal.data, acquisitionDate: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Depreciation / Month</label>
                                        <input style={formStyle.input} type="number" step="0.01" placeholder="0.00" value={modal.data.depreciationMonthly || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, depreciationMonthly: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>GPS Fee / Month</label>
                                        <input style={formStyle.input} type="number" step="0.01" placeholder="0.00" value={modal.data.gpsMonthly || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, gpsMonthly: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Dashcam Fee / Month</label>
                                        <input style={formStyle.input} type="number" step="0.01" placeholder="0.00" value={modal.data.dashcamMonthly || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, dashcamMonthly: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Insurance / Month</label>
                                        <input style={formStyle.input} type="number" step="0.01" placeholder="0.00" value={modal.data.insuranceMonthly || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, insuranceMonthly: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Other Costs / Month</label>
                                        <input style={formStyle.input} type="number" step="0.01" placeholder="0.00" value={modal.data.otherCostsMonthly || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, otherCostsMonthly: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Monthly Total</label>
                                        <div style={{ padding: '10px 14px', borderRadius: 8, background: 'linear-gradient(135deg,#eef2ff,#e0e7ff)', border: '1.5px solid #c7d2fe', fontWeight: 800, fontSize: 16, color: '#4338ca', textAlign: 'center' }}>
                                            {(
                                                (parseFloat(modal.data.depreciationMonthly) || 0) +
                                                (parseFloat(modal.data.gpsMonthly) || 0) +
                                                (parseFloat(modal.data.dashcamMonthly) || 0) +
                                                (parseFloat(modal.data.insuranceMonthly) || 0) +
                                                (parseFloat(modal.data.otherCostsMonthly) || 0)
                                            ).toFixed(2)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {modal.type === 'drivers' && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 24, padding: '10px 0' }}>
                                {/* Basic Information */}
                                <div>
                                    <h4 style={{ fontSize: 13, fontWeight: 800, color: '#1e293b', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #f1f5f9', paddingBottom: 8 }}>Basic Information</h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                                        <div style={{ ...formStyle.group, gridColumn: 'span 2' }}>
                                            <label style={formStyle.label}>Driver Name</label>
                                            <input style={formStyle.input} value={modal.data.name || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, name: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Email Address</label>
                                            <input style={formStyle.input} type="email" value={modal.data.email || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, email: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Country Code</label>
                                            <input style={formStyle.input} value={modal.data.countryCode || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, countryCode: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Phone Number</label>
                                            <input style={formStyle.input} value={modal.data.phoneNumber || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, phoneNumber: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Alt Phone</label>
                                            <input style={formStyle.input} value={modal.data.altPhone || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, altPhone: e.target.value } })} />
                                        </div>
                                    </div>
                                </div>
                                {/* Identity & Documentation */}
                                <div>
                                    <h4 style={{ fontSize: 13, fontWeight: 800, color: '#1e293b', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #f1f5f9', paddingBottom: 8 }}>Identity & Documentation</h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                                        <div style={{ ...formStyle.group, gridColumn: 'span 2' }}>
                                            <label style={formStyle.label}>Nationality</label>
                                            <input style={formStyle.input} value={modal.data.nationality || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, nationality: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Civil ID</label>
                                            <input style={formStyle.input} value={modal.data.civilId || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, civilId: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Civil ID Expiry</label>
                                            <input style={formStyle.input} type="date" value={modal.data.civilIdExpiry ? new Date(modal.data.civilIdExpiry).toISOString().split('T')[0] : ''} onChange={e => setModal({ ...modal, data: { ...modal.data, civilIdExpiry: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Passport Number</label>
                                            <input style={formStyle.input} value={modal.data.passportNumber || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, passportNumber: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Passport Expiry</label>
                                            <input style={formStyle.input} type="date" value={modal.data.passportExpiry ? new Date(modal.data.passportExpiry).toISOString().split('T')[0] : ''} onChange={e => setModal({ ...modal, data: { ...modal.data, passportExpiry: e.target.value } })} />
                                        </div>
                                    </div>
                                </div>
                                {/* Employment Specifics */}
                                <div>
                                    <h4 style={{ fontSize: 13, fontWeight: 800, color: '#1e293b', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #f1f5f9', paddingBottom: 8 }}>Employment Specifics</h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Driver Code</label>
                                            <input style={formStyle.input} value={modal.data.driverCode || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, driverCode: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>License Number</label>
                                            <input style={formStyle.input} value={modal.data.licenseNumber || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, licenseNumber: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>License Expiry</label>
                                            <input style={formStyle.input} type="date" value={modal.data.licenseExpiry ? new Date(modal.data.licenseExpiry).toISOString().split('T')[0] : ''} onChange={e => setModal({ ...modal, data: { ...modal.data, licenseExpiry: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Onboard Date</label>
                                            <input style={formStyle.input} type="date" value={modal.data.onboardDate ? new Date(modal.data.onboardDate).toISOString().split('T')[0] : ''} onChange={e => setModal({ ...modal, data: { ...modal.data, onboardDate: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Probation Period</label>
                                            <input style={formStyle.input} value={modal.data.probationPeriod || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, probationPeriod: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Accommodation Location</label>
                                            <input style={formStyle.input} value={modal.data.accommodationLocation || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, accommodationLocation: e.target.value } })} />
                                        </div>
                                        <div style={{ ...formStyle.group, gridColumn: 'span 2' }}>
                                            <label style={formStyle.label}>Status</label>
                                            <select style={formStyle.input} value={modal.data.status || 'Active'} onChange={e => setModal({ ...modal, data: { ...modal.data, status: e.target.value } })}>
                                                <option value="Active">Active</option>
                                                <option value="Inactive">Inactive</option>
                                                <option value="On Leave">On Leave</option>
                                                <option value="Resigned">Resigned</option>
                                                <option value="Terminated">Terminated</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* Payroll & Allowances */}
                                <div>
                                    <h4 style={{ fontSize: 13, fontWeight: 800, color: '#1e293b', marginBottom: 16, textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #f1f5f9', paddingBottom: 8 }}>Payroll & Allowances</h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Base Salary</label>
                                            <input style={formStyle.input} type="number" value={modal.data.baseSalary || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, baseSalary: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Fixed Allowances</label>
                                            <input style={formStyle.input} type="number" value={modal.data.fixedAllowances || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, fixedAllowances: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Overtime Rate</label>
                                            <input style={formStyle.input} type="number" value={modal.data.overtimeRate || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, overtimeRate: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Uniform Cost</label>
                                            <input style={formStyle.input} type="number" value={modal.data.uniformCost || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, uniformCost: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Accommodation Cost</label>
                                            <input style={formStyle.input} type="number" value={modal.data.accommodationCost || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, accommodationCost: e.target.value } })} />
                                        </div>
                                        <div style={formStyle.group}>
                                            <label style={formStyle.label}>Other Deduction</label>
                                            <input style={formStyle.input} type="number" value={modal.data.otherDeduction || ''} onChange={e => setModal({ ...modal, data: { ...modal.data, otherDeduction: e.target.value } })} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {modal.type === 'docs' && (
                            <>
                                <div style={formStyle.group}>
                                    <label style={formStyle.label}>Document Type</label>
                                    <select style={formStyle.input} value={modal.data.documentType} onChange={e => setModal({ ...modal, data: { ...modal.data, documentType: e.target.value } })}>
                                        <option value="">Select Type</option>
                                        {(masterData['document-types'] || []).map(m => <option key={m._id} value={m.name}>{m.name}</option>)}
                                    </select>
                                </div>
                                <div style={formStyle.group}>
                                    <label style={formStyle.label}>Description</label>
                                    <input style={formStyle.input} value={modal.data.description} onChange={e => setModal({ ...modal, data: { ...modal.data, description: e.target.value } })} />
                                </div>
                                <div style={formStyle.group}>
                                    <label style={formStyle.label}>Expiry Date</label>
                                    <input type="date" style={formStyle.input} value={modal.data.expiryDate ? modal.data.expiryDate.split('T')[0] : ''} onChange={e => setModal({ ...modal, data: { ...modal.data, expiryDate: e.target.value } })} />
                                </div>
                            </>
                        )}
                        {modal.type === 'contracts' && (
                            <>
                                <div style={formStyle.group}>
                                    <label style={formStyle.label}>Contract Type</label>
                                    <input style={formStyle.input} value={modal.data.contractType} onChange={e => setModal({ ...modal, data: { ...modal.data, contractType: e.target.value } })} />
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Start Date</label>
                                        <input type="date" style={formStyle.input} value={modal.data.startDate ? modal.data.startDate.split('T')[0] : ''} onChange={e => setModal({ ...modal, data: { ...modal.data, startDate: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>End Date</label>
                                        <input type="date" style={formStyle.input} value={modal.data.endDate ? modal.data.endDate.split('T')[0] : ''} onChange={e => setModal({ ...modal, data: { ...modal.data, endDate: e.target.value } })} />
                                    </div>
                                </div>
                                <div style={formStyle.group}>
                                    <label style={formStyle.label}>Contract Value</label>
                                    <input type="number" style={formStyle.input} value={modal.data.value} onChange={e => setModal({ ...modal, data: { ...modal.data, value: e.target.value } })} />
                                </div>
                            </>
                        )}
                        {modal.type === 'pricing' && (
                            <>
                                <div style={formStyle.group}>
                                    <label style={formStyle.label}>Service Type</label>
                                    <select style={formStyle.input} value={modal.data.serviceType} onChange={e => setModal({ ...modal, data: { ...modal.data, serviceType: e.target.value } })}>
                                        <option value="">Select Service</option>
                                        {(masterData['service-types'] || []).map(m => <option key={m._id} value={m.name}>{m.name}</option>)}
                                    </select>
                                </div>
                                <div style={formStyle.group}>
                                    <label style={formStyle.label}>Rate Type</label>
                                    <select style={formStyle.input} value={modal.data.rateType} onChange={e => setModal({ ...modal, data: { ...modal.data, rateType: e.target.value } })}>
                                        <option value="Fixed">Fixed</option>
                                        <option value="Per KM">Per KM</option>
                                        <option value="Per Trip">Per Trip</option>
                                    </select>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Rate</label>
                                        <input type="number" style={formStyle.input} value={modal.data.rate} onChange={e => setModal({ ...modal, data: { ...modal.data, rate: e.target.value } })} />
                                    </div>
                                    <div style={formStyle.group}>
                                        <label style={formStyle.label}>Currency</label>
                                        <input style={formStyle.input} value={modal.data.currency} onChange={e => setModal({ ...modal, data: { ...modal.data, currency: e.target.value } })} />
                                    </div>
                                </div>
                                <div style={formStyle.group}>
                                    <label style={formStyle.label}>Notes</label>
                                    <input style={formStyle.input} value={modal.data.notes} onChange={e => setModal({ ...modal, data: { ...modal.data, notes: e.target.value } })} />
                                </div>
                            </>
                        )}
                    </div>
                </Modal>
            )}

            {toast && (
                <div style={{
                    position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
                    background: toast.type === 'error' ? '#ef4444' : '#1e293b',
                    color: 'white', padding: '12px 24px', borderRadius: 12, fontSize: 14, fontWeight: 600,
                    boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)', zIndex: 2000,
                    animation: 'slideUp 0.3s ease-out'
                }}>
                    {toast.msg}
                </div>
            )}
        </div>
    );
}
